import { hasQuery } from '@apeiron/common'
import { QUERY_FILTER_WHITELIST } from '@apeiron/temp'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'

const useQueryInject = (query: Record<string, any>): Hook => {
  const router = useRouter()

  const queryStr = useMemo(() => JSON.stringify(query), [query])

  const [injected, setInjected] = useState<boolean>(false)

  useEffect(() => {
    const completeInject = () => {
      setInjected(true)
    }

    if (!hasQuery(router.asPath, QUERY_FILTER_WHITELIST)) {
      router.events.on('routeChangeComplete', completeInject)
      router.push(
        {
          pathname: router.pathname,
          query: {
            ...JSON.parse(queryStr),
            ...router.query
          }
        },
        '',
        { shallow: true }
      )

      return () => {
        return router.events.off('routeChangeComplete', completeInject)
      }
    } else {
      completeInject()
    }
  }, [queryStr, router])

  return {
    injected
  }
}

type Hook = {
  injected: boolean
}

export default useQueryInject
